import { render } from "./UserIdTd.vue?vue&type=template&id=336ad354&scoped=true"
import script from "./UserIdTd.vue?vue&type=script&lang=js"
export * from "./UserIdTd.vue?vue&type=script&lang=js"

import "./UserIdTd.vue?vue&type=style&index=0&id=336ad354&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336ad354"]])

export default __exports__